
export function EntityTransientTable(tableName: string, uuid?: string, external?: boolean): ClassDecorator {
    return function decorator(target: any) {
        target.prototype.__tableName = tableName;
        target.prototype.__uuid = uuid;
        target.prototype.__external = external;

        return target;
    };
}
